const caseInsensitiveSort = (data, column, sortAscending) => {
  sortAscending = typeof sortAscending === 'undefined' ? true : sortAscending;

  return data.sort((original, newRecord) => {
    let first = original.get(column);
    if (first !== null && typeof first._root !== 'undefined') {
      first = original.get(column)._root.entries[0][1].toLowerCase();
    } else if (first === null) {
      first = '';
    }

    let second = newRecord.get(column);
    if (second !== null && typeof newRecord.get(column)._root !== 'undefined') {
      second = newRecord.get(column)._root.entries[0][1].toLowerCase();
    } else if (second === null) {
      second = '';
    }

    if (first === second) {
      return 0;
    } else if (first > second) {
      return sortAscending ? 1 : -1;
    }
    return sortAscending ? -1 : 1;
  });
};

export default caseInsensitiveSort;



// WEBPACK FOOTER //
// ./src/helpers/caseInsensitiveSort.js